module.exports = __webpack_public_path__ + "static/media/career-counseling.e6b5de8e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/career-counseling.jpg
 ** module id = 770
 ** module chunks = 0
 **/